// Serial polling: a slow request never overlaps the next one, and stopped
// requests cannot update another closure after navigation.
export const createClosurePoller = ({ load, onData, onError, interval = 3000 }) => {
  let timer;
  let version = 0;
  let failures = 0;

  const stop = () => {
    version += 1;
    clearTimeout(timer);
  };

  const poll = async (currentVersion) => {
    let response;
    try {
      response = await load();
    } catch (error) {
      response = { ok: false, message: error.message };
    }
    if (currentVersion !== version) return;

    let keepPolling;
    if (response && response.ok) {
      failures = 0;
      keepPolling = onData(response);
    } else {
      failures += 1;
      keepPolling = ![400, 401, 403, 404].includes(Number(response?.status));
      onError(response, keepPolling);
    }
    if (keepPolling && currentVersion === version) {
      const delay = Math.min(interval * Math.max(1, failures), 15000);
      timer = setTimeout(() => poll(currentVersion), delay);
    }
  };

  return {
    start() {
      stop();
      failures = 0;
      return poll(version);
    },
    stop,
  };
};

export const generationPercentage = (generation) => {
  if (generation?.status === "completed") return 100;
  const total = Number(generation?.total) || 0;
  const completed = Number(generation?.completed) || 0;
  return total > 0 ? Math.max(0, Math.min(99, Math.floor((completed / total) * 100))) : 0;
};

export const generationLabel = (generation) => {
  if (!generation) return "";
  if (generation.status === "failed") return "No se pudieron generar los documentos";
  if (generation.status === "interrupted") return "La generación se interrumpió";
  if (generation.status === "completed") return "Documentos generados y guardados";
  return {
    queued: "Preparando documentos…",
    generating: "Generando PDF…",
    retrying: "Reintentando el PDF…",
    uploading: "Guardando PDF…",
    validating: "Validando documentos…",
  }[generation.phase] || "Procesando documentos…";
};
